import React from "react";

export default function Home() {
  return (
    <main className="min-vh-100 bg-dark text-light py-3" style={{    
      backgroundImage: `linear-gradient(to bottom right in oklab, lab(7.78673% 1.82346 -15.0537) 0%, lab(16.132% -.318021 -14.6672) 50%, #000 100%)`

    }}>
      <section className="container py-4">

        {/* HERO SECTION */}
        <div className="bg-opacity-25  backdrop-blur rounded-4 border border-secondary shadow p-4 p-md-5 d-flex flex-column flex-md-row gap-4 align-items-center">
          
          {/* Text */}
          <div className="flex-fill">
            <h1 className="display-5 fw-bold">
              Devkumar <span className="text-info">Parekh</span>
            </h1>
            <p className="mt-3 fs-5 text-light opacity-75">
              Frontend Developer — React.js · Next.js · JavaScript
            </p>

            <p className="mt-4 text-light">
              I’m a web developer with <strong>3.5+ years</strong> experience building
              performant interfaces using React and Next.js. I focus on performance,
              maintainable code, and Chrome Extensions that automate workflows.
            </p>

            {/* CTA Buttons */}
            <div className="mt-4 d-flex flex-wrap gap-3">
              <a href="/Resume_Devkumar_Parekh.pdf" download className="btn btn-info text-white px-4 py-2 shadow-sm">
                Download Resume
              </a>
              <a href="mailto:parekh2devkumar@gmail.com" className="btn btn-outline-light px-4 py-2">
                Email Me
              </a>
              <a href="tel:+918469025446" className="btn btn-outline-light px-4 py-2">
                Call Me
              </a>
            </div>

            <p className="mt-3 small text-light opacity-75">
              Surat, Gujarat • Available Immediately
            </p>
          </div>

          {/* Profile Picture */}
          <div className="text-center">
            <div className="rounded-4 overflow-hidden shadow border border-secondary" style={{ width: "180px", height: "180px" }}>
              <img src="./images/profilePlaceholder-trans.jpg" className="w-100 h-100 object-fit-cover" />
              
            </div>
          </div>
        </div>

        {/* CONTENT GRID */}
        <div className="row mt-3 g-4">

          {/* LEFT CONTENT */}
          <div className="col-md-8 d-flex flex-column gap-4">

            {/* ABOUT */}
            <Box title="About Me">
              <p className="text-light opacity-75">
                I enjoy building clean, performant user interfaces. I focus on component-driven
                architecture, readable code, and performance optimizations like lazy loading,
                memoization, and code splitting. I also build Chrome Extensions for automation.
              </p>
            </Box>

            {/* PROJECTS */}
            <Box title="Projects" subtitle="Featured Work & Chrome Extensions">
              <div className="row g-3 mt-2">
                <div className="col-md-6">
                  <ProjectCard
                    title="Hospitality Management Platform"
                    desc="Developed UI modules & automated workflows using custom React and event-driven architecture."
                    tech="React · JS · APIs"
                  />
                </div>
                <div className="col-md-6">
                  <ProjectCard
                    title="Chrome Extension Automation"
                    desc="Built full-feature extension with content scripts, workers and auto event triggers."
                    tech="WebExtensions API · JS"
                  />
                </div>
                <div className="col-md-6">
                  <ProjectCard
                    title="MLM Platform (Next.js)"
                    desc="Role-based UI, Redux-Thunk, REST APIs and modular reusable components."
                    tech="Next.js · Redux · Axios"
                  />
                </div>
                <div className="col-md-6">
                  <ProjectCard
                    title="E-commerce WooCommerce"
                    desc="Custom plugins, PHP functions & theme enhancements."
                    tech="WordPress · PHP · jQuery"
                  />
                </div>
              </div>
            </Box>

            {/* EXPERIENCE */}
            <Box title="Work Experience">
              <Experience
                role="React Developer — Instance IT Solutions"
                type="Full-time"
                desc="Built hospitality UI features, Chrome scraping extension, event-driven API workflows."
              />
              <Experience
                role="React Developer — Algoscript Pvt Ltd"
                type="Full-time"
                desc="Built modular Next.js UI, Redux-Thunk state, and API integrations."
              />
              <Experience
                role="Jr. Web Developer — Webconnect Pvt Ltd"
                type="Full-time"
                desc="Built plugins, child themes and WooCommerce stores using PHP & jQuery."
              />
            </Box>

            {/* EDUCATION */}
            <Box title="Education">
              <p className="mb-0 text-light">
                <strong>B.Tech (Information Technology)</strong>
              </p>
              <p className=" small text-light opacity-75">
                Uka Tarsadia University — 2018–2022
              </p>
            </Box>

            {/* ACHIEVEMENTS */}
            <Box title="Achievements & Certifications">
              <ul className="text-light opacity-75">
                <li>Quick Adaptation Award — Algoscript (2023)</li>
                <li>Best Employee Award — Webconnect (2022)</li>
              </ul>
            </Box>
          </div>

          {/* SIDEBAR */}
          <div className="col-md-4 d-flex flex-column gap-4">

            <SidebarBox title="Key Skills">
              <SkillGrid
                skills={[
                  "React.js", "Next.js", "JavaScript", "HTML", "CSS",
                  "Redux", "Context API", "REST APIs", "Chrome Extensions",
                  "Performance Optimization", "Git", "Debugging"
                ]}
              />
            </SidebarBox>

            <SidebarBox title="Contact">
              <p className="text-light opacity-75 small mb-1">
                Email: <a href="mailto:parekh2devkumar@gmail.com" className="text-info">parekh2devkumar@gmail.com</a>
              </p>
              <p className="text-light opacity-75 small mb-1">
                Phone: <a href="tel:+918469025446" className="text-info">+91 84690 25446</a>
              </p>
              <p className="text-light opacity-75 small mb-1">Location: Surat, Gujarat</p>
              <p className="text-light opacity-75 small">Languages: English, Hindi, Gujarati</p>
            </SidebarBox>

            <SidebarBox title="Tools & Workflow">
              <p className="text-light opacity-75 small">
                Git · GitHub · VS Code · NPM · Redux · Axios
              </p>
            </SidebarBox>

          </div>
        </div>

        {/* FOOTER */}
        <footer className="text-center mt-5 text-secondary small">
          © {new Date().getFullYear()} Devkumar Parekh — Built with React
        </footer>
      </section>
    </main>
  );
}

/* --- REUSABLE BOOTSTRAP COMPONENTS --- */

function Box({ title, subtitle, children }) {
  return (
    <div className="p-4 bg-opacity-25  rounded-4 border border-secondary shadow">
      <h2 className="h5 text-light">{title}</h2>
      {subtitle && <p className=" small text-light opacity-75">{subtitle}</p>}
      <div className="mt-2">{children}</div>
    </div>
  );
}

function SidebarBox({ title, children }) {
  return (
    <div className="p-4 bg-opacity-25  rounded-4 border border-secondary shadow">
      <h4 className="h6 text-light mb-3">{title}</h4>
      {children}
    </div>
  );
}

function ProjectCard({ title, desc, tech }) {
  return (
    <div className="p-3 bg-opacity-25  rounded-4 border border-secondary shadow-sm hover-shadow-lg">
      <h4 className="h6 text-light">{title}</h4>
      <p className="small  mt-2 text-light opacity-75">{desc}</p>
      <p className=" small mt-2 text-light opacity-75">Stack: {tech}</p>
    </div>
  );
}

function Experience({ role, type, desc }) {
  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between">
        <strong className="text-light">{role}</strong>
        <span className=" small text-light opacity-75">{type}</span>
      </div>
      <p className=" small mt-2 text-light opacity-75">{desc}</p>
    </div>
  );
}

function SkillGrid({ skills }) {
  return (
    <div className="row row-cols-2 g-2 text-light opacity-75 small">
      {skills.map((skill, index) => (
        <div key={index}>{skill}</div>
      ))}
    </div>
  );
}
